import { render } from "./CalendarEventMeetingTypeChooser.vue?vue&type=template&id=1e64b40a&scoped=true"
import script from "./CalendarEventMeetingTypeChooser.vue?vue&type=script&lang=ts"
export * from "./CalendarEventMeetingTypeChooser.vue?vue&type=script&lang=ts"

import "./CalendarEventMeetingTypeChooser.vue?vue&type=style&index=0&id=1e64b40a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e64b40a"

export default script